<template>
	<div>
		<div style="display: none;">
			<div>OOCC</div>
			<div>华人事业共创会</div>
			<div>OOCC华人事业共创会</div>
			<div>诚意发布2.0</div>
			<div>口袋里的华人事业人脉</div>
			<div>随时随地查看最新内推机会，动动手指即可联系到内推人招人信息快速触达海量求职者，众多优秀人才任你挑选</div>
			<div>Scan with your iPhone camera to download</div>
			<div>互联推荐人与求职者的APP OOCC求职伴侣已就位</div>
			<div>所有的机会，一切为华人</div>
			<div>Join us
become volunteer</div>
			<div>全球华人在这里携手共进，免费分享职位机会和求职经历，OOCC愿为华人事业的发展做出更大贡献。</div>
			<div>info@oocc.org</div>
			<div>内推机会不容错过哦</div>
			<div>新手求职上路，在职跳槽换赛道，机会多多!</div>
			<div>求面经？来这里找啊~</div>
			<div>招兵买马，
人才济济任你挑</div>
			<div>高效匹配，
为你省时省力</div>
			<div>一键内推，
快速联系内推人</div>
			<div>海量名企内推，真实可靠</div>
			<div>随时更新内推资源
让你投递忙不停</div>
			<div>精准匹配，高效求职</div>
			<div>求职信息精准匹配；与华人内推官直接沟通，一键内推</div>
			<div>求职安全放心</div>
			<div>信息安全监控, 内推职位风控, 保障你的个人隐私</div>
			<div>面试经验交流多多</div>
			<div>看面经!汇集面试经验分享，前辈亲身求职经历</div>
			<div>Offer不纠结</div>
			<div>薪资大揭秘，看准Offer潜力，选择不用愁</div>
			<div>永久免费</div>
			<div>成就全球华人求职梦想，服务华人事业公益平台</div>
			<div>hear it from the
community</div>
			<div>Nick Computer Science / UIUC</div>
			<div>朋友推荐来的，结果使用起来超乎我的想象！面经板块尤其赞，感恩大神们分享的面经资源以及板块的互动功能，让新手小白能够提前准备，在面试中临危不惧！</div>
			<div>Skyler L Business Analysis / NYU</div>
			<div>这个平台是真的棒！作为一个社恐，Networking是我求职的死穴，是这个平台拯救了我！这个平台的一键内推功能，让尴尬星人也能顺利拿到内推！真的太赞了！我只想说加油宝子们，冲鸭！</div>
			<div>琪琪 Finance / UCB</div>
			<div>真是一个宝藏APP，所有的资源都是免费的！！！平台上有很多内推机会和面经，真的是求职者的福音！手动点赞！</div>
			<div>Doris</div>
			<div>Credit Analyst / JP Morgan</div>
			<div>朋友推荐的，没想到体验感非常好！手机端就能快速完成职位发布、简历收集，还可以和求职者快速互动，利用碎片时间就可以完成筛选，希望可以帮助到更多需要内推的小伙伴。良心平台！</div>
			<div>Jackson Software Engineer / Tiktok</div>
			<div>很好的APP，我们组当时有两个急招岗位，这个平台让我们在很短的时间内收集到了很多简历，而且质量很不错，解决了我们的燃眉之急。推荐推荐！</div>
			<div>Amelia Data Scientist / Fortinet</div>
			<div>APP的界面非常友好，发布职位和筛选求职者既简单又高效。不仅让我们组招到了优秀的小伙伴，还为大家节省了大量的时间和资源。之后有需要还会再来的！</div>
			<div>WHO ARE WE</div>
			<div>华人事业共创会（Organization of Chinese Career）是美国政府批准成立的具有501(c)(3)资质的非盈利组织。我们源于华人，服务华人。
我们的愿望很朴实——帮助华人找到更好的工作机会，让华人在职场上更具竞争力。我们致力于打造一个专为华人设计的公益就业资源平台，无论你是刚毕业的求职新手，还是正在寻求新机会的职场达人，这里都能找到适合你的资源信息；不论你是有求职需求，还是有资源、经验想要分享给大家，都能让你有的放矢。快来加入我们，让我们一起把每个华人的职场梦想变成现实。赶紧下载我们的APP，开启你全新的职业旅程吧！</div>
			<div>我们在2022年获得了美国联邦政府501(c)(3)资质认证，2023年成功申请USCIS的E-Verify官方认证，并通过审批获得了D-U-N-S注册认证。OOCC成立至今，一直保持着联邦及州政府Good Standing商誉。</div>
			<div>today's the day,free to try,over 3m users,5/5raing</div>
			<div>我们是一群热衷于打造卓越用户体验的人，我们致力于打造世界上最好的属于华人的内推求职公益平台。</div>
			<div>商务合作 info@oocc.org</div>
			<div>工作时间 美西时间 9AM -6PM</div>
			<div>微信公众号 华人事业共创会</div>
			<div>成为志愿者</div>
			<div>由Organization of Chinese Career 2022年在美国上线，版权所有©Organization of Chinese Career</div>
		</div>
		<div v-if="ifPc == 1">
			<div style="height: 50vw;position: relative;">
				<el-carousel @change="changeBanner" :interval="interval" trigger="click" style="overflow: hidden;position: relative;z-index: 10;" height="50vw">
				      <el-carousel-item key="1">
				        <img style="width: 100%;height: auto;" src="../../public/image/banner1.png"/>
						<div @click="downloadApp" style="position: absolute;height: 25%;width: 12.5%;bottom: 16.5%;left:8.6%;cursor: pointer;"></div>
						
						<div @click="downloadApp" style="position: absolute;height: 6.3888%;width: 10.2%;top: 70%;left:23%;cursor: pointer;"></div>
						
						<div @click="downloadAndroid" style="position: absolute;height: 6.3888%;width: 10.2%;top: 70%;left:34.4%;cursor: pointer;"></div>
				      </el-carousel-item>
					  <el-carousel-item key="2">
					    <img style="width: 100%;height: auto;" src="../../public/image/banner2.png"/>
						
						<img class="message1" id="message51" style="width: auto;height:12%;position: absolute;top:39.5%;left:12%;" src="../../public/image/message/5-1.png"/>
						
						<img class="message1" id="message52" style="width: auto;height:12%;position: absolute;top:34.16%;left:82%;" src="../../public/image/message/5-2.png"/>
						
						<img class="message1" id="message1" style="width: auto;height:12%;position: absolute;top:43.88%;left:29%;" src="../../public/image/message/1.png"/>
						<img class="message1" id="message2" style="width: auto;height:12%;position: absolute;top:50.55%;left:62%;" src="../../public/image/message/2.png"/>
						<img class="message1" id="message3" style="width: auto;height:12%;position: absolute;top:58.19%;left:17.4%;" src="../../public/image/message/3.png"/>
						<img class="message1" id="message4" style="width: auto;height:12%;position: absolute;top:67.08%;left:72%;" src="../../public/image/message/4.png"/>
						
						
						
					  </el-carousel-item>
					  <el-carousel-item key="3" >
					    <img style="width: 100%;height: auto;" src="../../public/image/banner3.png"/>
						<div @click="copy" style="position: absolute;height: 5%;width: 11%;bottom: 50%;left:25%;cursor: pointer;"></div>
					  </el-carousel-item>
					  
				</el-carousel>
				<div @click="downloadApp" class="codeStyle" style="position: absolute;bottom:5%;right:5%;cursor: pointer;z-index: 20;">
					<img style="width: 100%;height: auto;" src="../../public/image/code.png"/>
				</div>
				
			</div>
			<img style="width: 100%;height: auto;margin-top: 1.8%;margin-bottom: 1.8%;" src="../../public/image/top.jpg"/>
			
			<div style="position: relative;margin-bottom:0;">
				<img style="width: 100%;height: auto;" src="../../public/image/rateBack.png"/>
				
				<div style="position:absolute;width:100%;top:50%;">
					<div style="margin-left: 5.69%;margin-right: 5.69%;position: relative;height:15vw;">
						<img class="image1" style="" src="../../public/image/rate1.png"/>
						<img class="image2" style="" src="../../public/image/rate2.png"/>
						<img class="image3" style="" src="../../public/image/rate3.png"/>
					</div>
					<div style="margin-left: 5.69%;margin-right: 5.69%;position: relative;height:15vw;">
						<img class="image1" style="" src="../../public/image/rate4.png"/>
						<img class="image2" style="" src="../../public/image/rate5.png"/>
						<img class="image3" style="" src="../../public/image/rate6.png"/>
					</div>
				</div>
			</div>
			
			<div style="position: relative;margin-top:-6px;">
				<img style="width: 100%;height: auto;margin-bottom:0px;z-index: 10;" src="../../public/image/about.jpg"/>
				<div @click="downloadApp" style="position: absolute;height: 3.5%;width: 11%;top:43.5%;left:8%;cursor: pointer;"></div>
			</div>
			
			<div style="position: relative;">
				<img style="width: 100%;height: auto;margin-top: 0px;" src="../../public/image/opencamera.png"/>
				<div class="zl-num one-zkfb"  title='<span class="max"></span>' @click="click" style="position: absolute;height: 74%;width: 90%;bottom:12.5%;left:4.5%;cursor: pointer;border-radius: 500px;"></div>
			</div>
			
			<div style="position: relative;">
				<img style="width: 100%;height: auto;margin-top: 0px;" src="../../public/image/contact.jpg"/>
				<div @click="copy" style="position: absolute;height: 5%;width: 9%;top:25.5%;left:53.5%;cursor: pointer;"></div>
				<div @click="downloadApp" style="position: absolute;height: 8.5%;width: 10.5%;top:22.5%;left:70%;cursor: pointer;"></div>
			</div>
			
		</div>
		<div v-if="ifPc == 2">
			
			<div style="height: 75vw;position: relative;">
				<el-carousel @change="changeBanner" :interval="interval" trigger="click" style="overflow: hidden;position: relative;z-index: 10;" height="75vw">
				      <el-carousel-item key="1">
				        <img style="width: 100%;height: auto;" src="../../public/image/phoneImage/banner1.jpg"/>
						<div @click="downloadApp" style="position: absolute;height: 21%;width: 13.5%;bottom: 17%;left:13.5%;cursor: pointer;"></div>
						
						<div @click="downloadApp" style="position: absolute;height: 7%;width: 10.7%;bottom: 22.00000%;left:28.1%;cursor: pointer;"></div>
						
						<div @click="downloadAndroid" style="position: absolute;height: 7%;width: 10.7%;bottom:22.00000%;left:39.4%;cursor: pointer;"></div>
				      </el-carousel-item>
					  <el-carousel-item key="2">
					    <img style="width: 100%;height: auto;" src="../../public/image/phoneImage/banner2.jpg"/>
					  </el-carousel-item>
					  <el-carousel-item key="3" >
					    <img style="width: 100%;height: auto;" src="../../public/image/phoneImage/banner3.jpg"/>
						<div @click="copy" style="position: absolute;height: 5%;width:18%;bottom:19.50000%;left:7%;cursor: pointer;"></div>
					  </el-carousel-item>
					  
				</el-carousel>
				
			</div>
			<img style="width: 100%;height: auto;" src="../../public/image/phoneImage/top.jpg"/>
			
			<div style="position: relative;">
				<img style="width: 100%;height: auto;" src="../../public/image/phoneImage/rateBack.png"/>
				
				<div style="position:absolute;width:100%;top:37%;">
					<div style="margin-left:12.5%;margin-right:12.5%;position: relative;height:19vw;">
						<img class="image11" style="" src="../../public/image/rate1.png"/>
						<img class="image22" style="" src="../../public/image/rate2.png"/>
					</div>
					<div style="margin-left:12.5%;margin-right:12.5%;position: relative;height:19vw;">
						<img class="image11" style="" src="../../public/image/rate3.png"/>
						<img class="image22" style="" src="../../public/image/rate4.png"/>
					</div>
					<div style="margin-left:12.5%;margin-right:12.5%;position: relative;height:19vw;">
						<img class="image11" style="" src="../../public/image/rate5.png"/>
						<img class="image22" style="" src="../../public/image/rate6.png"/>
					</div>
				</div>
			</div>
			<div style="position: relative;margin-top:-3vw;">
				<img style="width: 100%;height: auto;margin-bottom:0px;z-index: 10;" src="../../public/image/phoneImage/about.jpg"/>
				<div @click="downloadApp" style="position: absolute;height: 4%;width: 13.5%;top:45.5%;left:11%;cursor: pointer;"></div>
			</div>
			
			<div style="position: relative;">
				<img style="width: 100%;height: auto;margin-top: 0px;" src="../../public/image/opencamera.png"/>
			</div>
			
			<div style="position: relative;">
				<img style="width: 100%;height: auto;margin-top: 0px;" src="../../public/image/phoneImage/contact.jpg"/>
				<div @click="copy" style="position: absolute;height: 5%;width:16%;top:37%;left:14.5%;cursor: pointer;"></div>
				<div @click="downloadApp" style="position: absolute;height: 8%;width: 18%;top:69%;left:12.5%;cursor: pointer;"></div>
			</div>
			
		</div>
	</div>
	
</template>
<script>
	 $(function () {
		var x = 10;
		var y = 20;
		var newtitle = '';
		// 一级分支线阻抗均值 悬停信息
		$('div.one-zkfb').mouseover(function (e) {
			newtitle = this.title;
			this.title = '';
			$('body').append('<div id="mytitle" >' + newtitle + '</div>');
			$('.max').html('Open your camera')  // 可以对title中的标签内容进行修改
 
			$('#mytitle').css({
				'left': (e.pageX + x + 'px'),
				'top': (e.pageY + y - 80 + 'px')
			}).show();
		}).mouseout(function () {
			this.title = newtitle;
			$('#mytitle').remove();
		}).mousemove(function (e) {
			$('#mytitle').css({ // title框的样式
				'left': (e.pageX + x +10 + 'px'),
				'top': (e.pageY + y - 20 + 'px')
			}).show();
		})
	});
	
	var downLoadUrl = "https://apps.apple.com/cn/app/oocc/id6449451965";
	var email = "info@oocc.org";
	import $ from 'jquery';
	import axios from 'axios';
	export default {
		name: 'App',
		data() {
			return {
				index:0,
				interval:8000,
				ifPc:1,
			}
		},
		computed: {
			
			
		},
		methods: {
			click(){
				
			},
			showMessage(){
				setTimeout(function() {
				  var image1 = document.getElementById("message1");
				  image1.classList.add("showMessage");
				  
				  setTimeout(function() {
				    var image1 = document.getElementById("message2");
				    image1.classList.add("showMessage");
					
					setTimeout(function() {
					  var image1 = document.getElementById("message3");
					  image1.classList.add("showMessage");
					}, 200);
					
					setTimeout(function() {
					  var image1 = document.getElementById("message4");
					  image1.classList.add("showMessage");
					  
					  setTimeout(function() {
					    var image1 = document.getElementById("message51");
					    image1.classList.add("showMessage");
						var image1 = document.getElementById("message52");
						image1.classList.add("showMessage");
					  }, 200);
					  
					}, 200);
					
				  }, 200);
				  
				}, 400);
				
				
			},
			hiddenMessage(){
				var image1 = document.getElementById("message1");
				image1.classList.remove("showMessage");
				var image1 = document.getElementById("message2");
				image1.classList.remove("showMessage");
				var image1 = document.getElementById("message3");
				image1.classList.remove("showMessage");
				var image1 = document.getElementById("message4");
				image1.classList.remove("showMessage");
				var image1 = document.getElementById("message51");
				image1.classList.remove("showMessage");
				var image1 = document.getElementById("message52");
				image1.classList.remove("showMessage");
			},
			copy(){
				  var textarea = document.createElement('textarea');
				  textarea.style.position = 'fixed';
				  textarea.style.opacity = 0;
				  textarea.value = email;
				  document.body.appendChild(textarea);
				  textarea.select();
				  document.execCommand('copy');
				  document.body.removeChild(textarea);
				  this.$message({
				  	message: '邮箱已复制到剪切板',
				  	type: 'success',
				  })
			},
			
			//创建临时的输入框元素
			createElement(text) {
				var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
				var element = document.createElement('textarea');
				// 防止在ios中产生缩放效果
				element.style.fontSize = '12pt';
				// 重置盒模型
				element.style.border = '0';
				element.style.padding = '0';
				element.style.margin = '0';
				// 将元素移到屏幕外
				element.style.position = 'absolute';
				element.style[isRTL ? 'right' : 'left'] = '-9999px';
				// 移动元素到页面底部
				let yPosition = window.pageYOffset || document.documentElement.scrollTop;
				element.style.top = `${yPosition}px`;
				//设置元素只读
				element.setAttribute('readonly', '');
				element.value = text;
				document.body.appendChild(element);
				return element;
			},
			changeBanner(item){
				console.log(item)
				this.index = item;
				if(item == 0){
					this.interval = 8000;
				}else{
					this.interval = 4000;
				}
				
				if(item == 1){
					this.showMessage();
				}else{
					this.hiddenMessage();
				}
			},
			 handleResize() {
				if(window.innerWidth < 1200){
					this.ifPc = 2;
				}else{
					this.ifPc = 1;
				}
			  },
			downloadApp(){
				window.location.href = downLoadUrl;
			},
			downloadAndroid(){
				
			},
			gotoApp(){
				document.getElementById("value").innerHTML = "请前往AppStore查看";
				window.location.href = downLoadUrl;
				return;
			},
		},
		mounted() {
			window.addEventListener('resize', this.handleResize)
			if(window.innerWidth < 1200){
				this.ifPc = 2;
			}else{
				this.ifPc = 1;
			}
		},
		  beforeDestroy() {
		    window.removeEventListener('resize', this.handleResize)
		  },

	}
</script>

<style lang="less">
	*{
		margin:0px;
		padding:0px;
	}
	body,html{
		font-family: 'HarmonyOS Sans SC';
		
		height:100%;
	}
	
	.message1{
		transition: all 0.8s;
		-moz-transition: all 0.8s;
		/* Firefox 4 */
		-webkit-transition: all 0.8s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.8s;
		opacity: 0;
	}
	
	
	.showMessage{
		opacity: 1;
	}
	
	
	.codeStyle{
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		height: 25.97%;width: 10.41%;
	}
	.codeStyle:hover{
		height: 55.55%;width: 22.22%;
	}
	
	.el-carousel__button{
		background: #0000001A;
	}

	.el-carousel__indicator.is-active button {
		background: #CC3333;
	}
	
	.image1{
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		width: 32.26%;
		height: auto;
		
		position: absolute;
		top:0%;
		left:0%;
		z-index:10;
	}
	.image1:hover{
		width: 40.7%;
		margin-right: -4.22%;
		margin-left: -4.22%;
		margin-top:-2%;
		z-index:20;
	}
	
	.image2{
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		width: 32.26%;
		height: auto;
		
		position: absolute;
		top:0%;
		left:33.86%;
		z-index:10;
	}
	.image2:hover{
		width: 40.7%;
		margin-right: -4.22%;
		margin-left: -4.22%;
		margin-top:-2%;
		z-index:20;
	}
	
	.image3{
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		width: 32.26%;
		height: auto;
		
		position: absolute;
		top:0%;
		left:67.72%;
		z-index:10;
	}
	.image3:hover{
		width: 40.7%;
		margin-right: -4.22%;
		margin-left: -4.22%;
		margin-top:-2%;
		z-index:20;
	}
	
	 #mytitle {
	        width: 200px;
			border-radius: 10px;
	        position: absolute;
	        font-size: 20px;
	        background: rgba(255, 255, 255,1);
	        text-align: center;
	        line-height: 22px;
			padding-top:12px;
			padding-bottom:12px;
	}
	
	.image11{
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		width: 48.8%;
		height: auto;
		
		position: absolute;
		top:0%;
		left:0%;
		z-index:10;
	}
	.image11:hover{
		width: 60.8%;
		margin-right: -5%;
		margin-left: -5%;
		margin-top:-2.5%;
		z-index:20;
	}
	
	.image22{
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		width: 48.8%;
		height: auto;
		
		position: absolute;
		top:0%;
		left:52.4%;
		z-index:10;
	}
	.image22:hover{
		width: 60.8%;
		margin-right: -5%;
		margin-left: -5%;
		margin-top:-2.5%;
		z-index:20;
	}
	
	
</style>
